export const imagesspkombat = [
  {
    id: "DOCUMENTARY_MMA",
    description: "Revivez l'intensité du MMA.",
    title: "Documentaires",
    label: "DOCUMENTARY_MMA",
    backdrop_path: "/images/spkombat/spkombat.jpg",
    poster_path: "/images/spkombat/spkombat.jpg",
    overview: "Chaîne officielle DOCUMENTARY_MMA.",
    vote_average: 8.5,
    release_date: "2020-01-01",
    genre_ids: [30, 31, 32, 30]
  },
  {
    id: "INTERVIEW_MMA",
    description: "Revivez l'intensité du MMA.",
    title: "Interviews",
    label: "INTERVIEW_MMA",
    backdrop_path: "/images/spkombat/spkombat.jpg",
    poster_path: "/images/spkombat/spkombat.jpg",
    overview: "Chaîne officielle INTERVIEW_MMA.",
    vote_average: 8.5,
    release_date: "2020-01-01",
    genre_ids: [30, 31, 32, 30]
  },
  {
    id: "KOMBAT_SHOW",
    description: "Reportages Fight & Arts martiaux.",
    title: "Reportages",
    label: "KOMBAT_SHOW",
    backdrop_path: "/images/spkombat/spkombat.jpg",
    poster_path: "/images/spkombat/spkombat.jpg",
    overview: "Chaîne officielle KOMBAT_SHOW.",
    vote_average: 8.5,
    release_date: "2020-01-01",
    genre_ids: [30, 31, 32, 30]
  },
  {
    id: "KOMBAT_MMA",
    description: "Revivez l'intensité du MMA.",
    title: "Fight MMA",
    label: "KOMBAT_MMA",
    backdrop_path: "/images/spkombat/spkombat.jpg",
    poster_path: "/images/spkombat/spkombat.jpg",
    overview: "Chaîne officielle KOMBAT_MMA.",
    vote_average: 8.5,
    release_date: "2020-01-01",
    genre_ids: [30, 31, 32, 30]
  },
  {
    id: "KOMBAT_MUAY_THAI",
    description: "Au coeur du Muay Thai.",
    title: "Muay Thai",
    label: "KOMBAT_MUAY_THAI",
    backdrop_path: "/images/spkombat/spkombat.jpg",
    poster_path: "/images/spkombat/spkombat.jpg",
    overview: "Chaîne officielle KOMBAT_MUAY_THAI.",
    vote_average: 8.5,
    release_date: "2020-01-01",
    genre_ids: [30, 31, 32, 30]
  },
  {
    id: "KOMBAT_K1",
    description: "Le meilleur du K-1.",
    title: "Legandary K1",
    label: "KOMBAT_K1",
    backdrop_path: "/images/spkombat/spkombat.jpg",
    poster_path: "/images/spkombat/spkombat.jpg",
    overview: "Chaîne officielle KOMBAT_MUAY_THAI.",
    vote_average: 8.5,
    release_date: "2020-01-01",
    genre_ids: [30, 31, 32, 30]
  },
  {
    id: "KOMBAT_BOXE",
    description: "Toute l'actualité de la boxe.",
    title: "Boxe",
    label: "KOMBAT_BOXE",
    backdrop_path: "/images/spkombat/spkombat.jpg",
    poster_path: "/images/spkombat/spkombat.jpg",
    overview: "Chaîne officielle KOMBAT_BOXE.",
    vote_average: 8.5,
    release_date: "2020-01-01",
    genre_ids: [30, 31, 32, 30]
  },
  {
    id: "ufc",
    title: "UFC",
    label: "ufc",
    backdrop_path: "/images/spkombat/spkombat.jpg",
    poster_path: "/images/spkombat/spkombat.jpg",
    overview: "Chaîne officielle UFC.",
    vote_average: 8.5,
    release_date: "2020-01-01",
    genre_ids: [30, 31, 32, 30]
  },
  {
    id: "BellatorMMA",
    title: "Bellator",
    label: "BellatorMMA",
    backdrop_path: "/images/spkombat/spkombat.jpg",
    poster_path: "/images/spkombat/spkombat.jpg",
    overview: "Chaîne officielle Bellator MMA.",
    vote_average: 8.5,
    release_date: "2020-01-01",
    genre_ids: [30, 31, 32, 30]
  },
  {
    id: "KarateCombat",
    title: "Karate Combat",
    label: "KarateCombat",
    backdrop_path: "/images/spkombat/spkombat.jpg",
    poster_path: "/images/spkombat/spkombat.jpg",
    overview: "Chaîne officielle Bellator MMA.",
    vote_average: 8.5,
    release_date: "2020-01-01",
    genre_ids: [30, 31, 32, 30]
  },
  {
    id: "ONEChampionship",
    title: "ONE Championship",
    label: "ONEChampionship",
    backdrop_path: "/images/spkombat/spkombat.jpg",
    poster_path: "/images/spkombat/spkombat.jpg",
    overview: "Chaîne officielle ONE Championship.",
    vote_average: 8.5,
    release_date: "2020-01-01",
    genre_ids: [30, 31, 32, 30]
  }
];
export const imagesCultureFr = [
  {
    id: "arte",
    title: "Arte",
    label: "arte",
    backdrop_path: "/images/logo-arte.png",
    poster_path: "/images/logo-arte.png",
    overview: "Chaîne culturelle européenne.",
    vote_average: 9.0,
    release_date: "2020-01-01",
    genre_ids: [30, 31, 32, 30]
  }
];
export const imagesWmb = [
  {
    id: "metal-blade-records",
    title: "Metal Blade Records",
    label: "MetalBladeRecords",
    description: "Metal Blade Records - Home of extreme metal music",
    backdrop_path: "/images/music-labels/metal-blade-records.jpg",
    poster_path: "/images/music-labels/metal-blade-records.jpg",
    overview: "Metal Blade Records - Home of extreme metal music",
    vote_average: 8.5,
    release_date: "2020-01-01",
    genre_ids: [100, 101, 102, 103, 104]
  },

  {
    id: "nuclear-blast",
    title: "Nuclear Blast",
    label: "NuclearBlastEurope",
    backdrop_path: "/images/music-labels/nuclear-blast-records.jpg",
    poster_path: "/images/music-labels/nuclear-blast-records.jpg",
    overview: "Nuclear Blast - The world's largest independent heavy metal label",
    vote_average: 9.0,
    release_date: "2020-01-01",
    genre_ids: [100, 101, 102, 103, 104]
  },
  {
    id: "earache-records",
    title: "Earache Records",
    label: "earacherecords",
    backdrop_path: "/images/music-labels/earache-records.jpg",
    poster_path: "/images/music-labels/earache-records.jpg",
    overview: "Earache Records - Extreme music since 1985",
    vote_average: 8.7,
    release_date: "2020-01-01",
    genre_ids: [100, 101, 102, 103, 104]
  },
  {
    id: "napalm-records",
    title: "Napalm Records",
    label: "napalmrecords",
    backdrop_path: "/images/music-labels/napalm-records.jpg",
    poster_path: "/images/music-labels/napalm-records.jpg",
    overview: "Napalm Records - Independent heavy music label",
    vote_average: 8.3,
    release_date: "2020-01-01",
    genre_ids: [100, 101, 102, 103, 104]
  },
  // {
  //   id: "metallica",
  //   title: "Metallica",
  //   label: "metallica",
  //   backdrop_path: "/images/music-labels/metallica.jpg",
  //   poster_path: "/images/music-labels/metallica.jpg",
  //   overview: "Metallica - Legendary heavy metal band",
  //   vote_average: 9.5,
  //   release_date: "2020-01-01",
  //   genre_ids: [100, 101, 102, 103, 104]
  // },
  {
    id: "season-of-mist",
    title: "Season of Mist",
    label: "SeasonOfMistLabel",
    backdrop_path: "/images/music-labels/season-of-mist-label.jpg",
    poster_path: "/images/music-labels/season-of-mist-label.jpg",
    overview: "Season of Mist - Extreme metal and alternative music",
    vote_average: 8.4,
    release_date: "2020-01-01",
    genre_ids: [100, 101, 102, 103, 104]
  },
  {
    id: "sumerian-records",
    title: "Sumerian Records",
    label: "SumerianRecords",
    backdrop_path: "/images/music-labels/sumerian-records.jpg",
    poster_path: "/images/music-labels/sumerian-records.jpg",
    overview: "Sumerian Records - Modern heavy music label",
    vote_average: 8.6,
    release_date: "2020-01-01",
    genre_ids: [100, 101, 102, 103, 104]
  },
  {
    id: "peaceville-records",
    title: "Peaceville Records",
    label: "PeacevilleRecords",
    backdrop_path: "/images/music-labels/peaceville-records.jpg",
    poster_path: "/images/music-labels/peaceville-records.jpg",
    overview: "Peaceville Records - Home of doom and extreme metal",
    vote_average: 8.8,
    release_date: "2020-01-01",
    genre_ids: [100, 101, 102, 103, 104]
  },
  {
    id: "relapse-records",
    title: "Relapse Records",
    label: "RelapseRecords",
    backdrop_path: "/images/music-labels/relapse-records.jpg",
    poster_path: "/images/music-labels/relapse-records.jpg",
    overview: "Relapse Records - Extreme music since 1990",
    vote_average: 8.5,
    release_date: "2020-01-01",
    genre_ids: [100, 101, 102, 103, 104]
  },
  {
    id: "roadrunner-records",
    title: "RoadRunner Records",
    label: "RoadRunnerUK",
    backdrop_path: "/images/music-labels/road-runner-records.jpg",
    poster_path: "/images/music-labels/road-runner-records.jpg",
    overview: "Roadrunner Records - Heavy metal and hard rock",
    vote_average: 9.1,
    release_date: "2020-01-01",
    genre_ids: [100, 101, 102, 103, 104]
  },
  {
    id: "afm-records",
    title: "AFM Records",
    label: "afmrecords",
    backdrop_path: "/images/music-labels/afm-records.jpg",
    poster_path: "/images/music-labels/afm-records.jpg",
    overview: "AFM Records - Heavy metal and hard rock label",
    vote_average: 8.2,
    release_date: "2020-01-01",
    genre_ids: [100, 101, 102, 103, 104]
  },
  {
    id: "century-media-records",
    title: "Century Media Records",
    label: "CenturyMedia",
    backdrop_path: "/images/music-labels/century-media-records.jpg",
    poster_path: "/images/music-labels/century-media-records.jpg",
    overview: "Century Media Records - Heavy music since 1988",
    vote_average: 8.9,
    release_date: "2020-01-01",
    genre_ids: [100, 101, 102, 103, 104]
  },
  {
    id: "reigning-phoenix-music",
    title: "Reigning Phoenix Music",
    label: "ReigningPhoenixMusicOfficial",
    backdrop_path: "/images/music-labels/reigning-phoenix-music.jpg",
    poster_path: "/images/music-labels/reigning-phoenix-music.jpg",
    overview: "Reigning Phoenix Music - Rising label in heavy music",
    vote_average: 8.9,
    release_date: "2020-01-01",
    genre_ids: [100, 101, 102, 103, 104]
  },
  {
    id: "bvtv",
    title: "BVTV",
    label: "BVTV",
    backdrop_path: "/images/music-labels/bvtv.jpg",
    poster_path: "/images/music-labels/bvtv.jpg",
    overview: "BVTV - Rising label in heavy music",
    vote_average: 8.9,
    release_date: "2020-01-01",
    genre_ids: [100, 101, 102, 103, 104]
  },
  {
    id: "OutOfLineMusic",
    title: "OutOfLineMusic",
    label: "OutOfLineMusic",
    backdrop_path: "/images/music-labels/bvtv.jpg",
    poster_path: "/images/music-labels/bvtv.jpg",
    overview: "OutOfLineMusic - Rising label in heavy music",
    vote_average: 8.9,
    release_date: "2020-01-01",
    genre_ids: [100, 101, 102, 103, 104]
  },
  {
    id: "music-video",
    title: "Music Video",
    label: "MUSIC_VIDEO",
    description: "Music Video - Home of extreme metal music",
    backdrop_path: "/images/music-labels/metal-blade-records.jpg",
    poster_path: "/images/music-labels/metal-blade-records.jpg",
    overview: "Music Video - Home of extreme metal music",
    vote_average: 8.5,
    release_date: "2020-01-01",
    genre_ids: [100, 101, 102, 103, 104]
  },
  {
    id: "lyrics-video",
    title: "Lyrics Video",
    label: "LYRICS_VIDEO",
    description: "Lyrics Video - Home of extreme metal music",
    backdrop_path: "/images/music-labels/metal-blade-records.jpg",
    poster_path: "/images/music-labels/metal-blade-records.jpg",
    overview: "Lyrics Video - Home of extreme metal music",
    vote_average: 8.5,
    release_date: "2020-01-01",
    genre_ids: [100, 101, 102, 103, 104]
  },  
  {
    id: "visualizer-video",
    title: "Visualizer Video",
    label: "VISUALIZER_VIDEO",
    description: "Visualizer Video - Home of extreme metal music",
    backdrop_path: "/images/music-labels/metal-blade-records.jpg",
    poster_path: "/images/music-labels/metal-blade-records.jpg",
    overview: "Visualizer Video - Home of extreme metal music",
    vote_average: 8.5,
    release_date: "2020-01-01",
    genre_ids: [100, 101, 102, 103, 104]
  },  
  {
    id: "documentation-metal",
    title: "Documentation Metal",
    label: "DOCUMENTATION_METAL",
    description: "Documentation Metal - Home of extreme metal music",
    backdrop_path: "/images/music-labels/metal-blade-records.jpg",
    poster_path: "/images/music-labels/metal-blade-records.jpg",
    overview: "Documentation Metal - Home of extreme metal music",
    vote_average: 8.5,
    release_date: "2020-01-01",
    genre_ids: [100, 101, 102, 103, 104]
  },
  {
    id: "interview-metal",
    title: "Interview Metal",
    label: "INTERVIEW_METAL",
    description: "Interview Metal - Home of extreme metal music",
    backdrop_path: "/images/music-labels/metal-blade-records.jpg",
    poster_path: "/images/music-labels/metal-blade-records.jpg",
    overview: "Interview Metal - Home of extreme metal music",
    vote_average: 8.5,
    release_date: "2020-01-01",
    genre_ids: [100, 101, 102, 103, 104]
  },
  {
    id: "live-performance",
    title: "Live Performance",
    label: "LIVE_PERFORMANCE",
    description: "Live Performance - Home of extreme metal music",
    backdrop_path: "/images/music-labels/metal-blade-records.jpg",
    poster_path: "/images/music-labels/metal-blade-records.jpg",
    overview: "Live Performance - Home of extreme metal music",
    vote_average: 8.5,
    release_date: "2020-01-01",
    genre_ids: [100, 101, 102, 103, 104]
  },
  {
    id: "OutlawCountry01-h7k",
    title: "Outlaw Country",
    label: "OutlawCountry01-h7k",
    description: "Outlaw Country - Home of outlaw country music",
    backdrop_path: "/images/music-labels/metal-blade-records.jpg",
    poster_path: "/images/music-labels/metal-blade-records.jpg",
    overview: "Outlaw Country - Home of outlaw country music",
    vote_average: 8.5,
    release_date: "2020-01-01",
    genre_ids: [100, 101, 102, 103, 104]
  },
  {
    id: "hillbilly_hellfire",
    title: "Hillbilly Hellfire",
    label: "Hillbilly Hellfire",
    description: "Hillbilly Hellfire - Home of outlaw country music",
    backdrop_path: "/images/music-labels/metal-blade-records.jpg",
    poster_path: "/images/music-labels/metal-blade-records.jpg",
    overview: "Hillbilly Hellfire - Home of outlaw country music",
    vote_average: 8.5,
    release_date: "2020-01-01",
    genre_ids: [100, 101, 102, 103, 104]
  },
  {
    id: "the_devil_inside",
    title: "The Devil Inside",
    label: "the_devil_inside",
    description: "The Devil Inside - Home of outlaw country music",
    backdrop_path: "/images/music-labels/metal-blade-records.jpg",
    poster_path: "/images/music-labels/metal-blade-records.jpg",
    overview: "The Devil Inside - Home of outlaw country music",
    vote_average: 8.5,
    release_date: "2020-01-01",
    genre_ids: [100, 101, 102, 103, 104]
  },
  {
    id: "SoulHealsMusic",
    title: "Soul Heals",
    label: "SoulHealsMusic",
    description: "SoulHealsMusic - Home of outlaw country music",
    backdrop_path: "/images/music-labels/metal-blade-records.jpg",
    poster_path: "/images/music-labels/metal-blade-records.jpg",
    overview: "SoulHealsMusic - Home of outlaw country music",
    vote_average: 8.5,
    release_date: "2020-01-01",
    genre_ids: [100, 101, 102, 103, 104]
  },
];

export const imagesTropical = [
  {
    id: "reggaeton",
    title: "Reggaeton",
    label: "REGGAETON",
    backdrop_path: "/images/music-labels/latino/reggaeton.jpg",
    poster_path: "/images/music-labels/latino/reggaeton.jpg",
    overview: "Reggaeton - Latin music genre",
    vote_average: 8.9,
    release_date: "2020-01-01",
    genre_ids: [200, 201, 202, 203, 204]
  },
  {
    id: "HIPHOP_LATINO",
    title: "Hip Hop",
    label: "HIPHOP_LATINO",
    backdrop_path: "/images/music-labels/latino/hiphop-latino.jpg",
    poster_path: "/images/music-labels/latino/hiphop-latino.jpg",
    overview: "Hip Hop Latino - Latin hip hop genre",
    vote_average: 8.9,
    release_date: "2020-01-01",
    genre_ids: [200, 201, 202, 203, 204]
  },
  {
    id: "TIMBA",
    title: "Timba",
    label: "TIMBA",
    backdrop_path: "/images/music-labels/latino/timba.jpg",
    poster_path: "/images/music-labels/latino/timba.jpg",
    overview: "TIMBA - Latin music genre",
    vote_average: 8.9,
    release_date: "2020-01-01",
    genre_ids: [200, 201, 202, 203, 204]
  },
  {
    id: "RUMBA",
    title: "Rumba",
    label: "RUMBA",
    backdrop_path: "/images/music-labels/latino/rumba.jpg",
    poster_path: "/images/music-labels/latino/rumba.jpg",
    overview: "Rumba - Latin music genre",
    vote_average: 8.9,
    release_date: "2020-01-01",
    genre_ids: [200, 201, 202, 203, 204]
  },
  {
    id: "cumbia",
    title: "Cumbia",
    label: "CUMBIA",
    backdrop_path: "/images/music-labels/latino/cumbia.jpg",
    poster_path: "/images/music-labels/latino/cumbia.jpg",
    overview: "Cumbia - Latin music genre",
    vote_average: 8.9,
    release_date: "2020-01-01",
    genre_ids: [200, 201, 202, 203, 204]
  },
  {
    id: "documentario-latino",
    title: "Documentario latino",
    label: "DOCUMENTARIO_LATINO",
    backdrop_path: "/images/music-labels/latino/documentario-latino.jpg",
    poster_path: "/images/music-labels/latino/documentario-latino.jpg",
    overview: "Documentario latino - Latin music genre",
    vote_average: 8.9,
    release_date: "2020-01-01",
    genre_ids: [200, 201, 202, 203, 204]
  },
  {
    id: "entrevista-latino",
    title: "Entrevista latino",
    label: "ENTREVISTA_LATINO",
    backdrop_path: "/images/music-labels/latino/entrevista-latino.jpg",
    poster_path: "/images/music-labels/latino/entrevista-latino.jpg",
    overview: "Entrevista latino - Latin music genre",
    vote_average: 8.9,
    release_date: "2020-01-01",
    genre_ids: [200, 201, 202, 203, 204]
  },
  {
    id: "universalmusica",
    title: "Universal Musica",
    label: "universalmusica",
    backdrop_path: "/images/music-labels/latino/daddy-yankee.jpg",
    poster_path: "/images/music-labels/latino/daddy-yankee.jpg",
    overview: "Universal Musica - The King of Reggaeton",
    vote_average: 9.2,
    release_date: "2020-01-01",
    genre_ids: [200, 201, 202, 203, 204]
  },
  {
    id: "laindustriainc",
    title: "La Industria Inc.",
    label: "laindustriainc",
    backdrop_path: "/images/music-labels/latino/la-industria-inc.jpg",
    poster_path: "/images/music-labels/latino/la-industria-inc.jpg",
    overview: "La Industria Inc. - Home of Latin trap and reggaeton",
    vote_average: 9.2,
    release_date: "2020-01-01",
    genre_ids: [200, 201, 202, 203, 204]
  },
  {
    id: "nicky-jam",
    title: "Nicky Jam",
    label: "NickyJamTV",
    backdrop_path: "/images/music-labels/latino/nicky-jam-tv.jpg",
    poster_path: "/images/music-labels/latino/nicky-jam-tv.jpg",
    overview: "Nicky Jam - American reggaeton artist",
    vote_average: 8.6,
    release_date: "2020-01-01",
    genre_ids: [200, 201, 202, 203, 204]
  },
  {
    id: "warner-music-latina",
    title: "Warner Music Latina",
    label: "warnermusiclatina",
    backdrop_path: "/images/music-labels/latino/warner-music-latina.jpg",
    poster_path: "/images/music-labels/latino/warner-music-latina.jpg",
    overview: "Warner Music Latina - Latin music powerhouse",
    vote_average: 8.9,
    release_date: "2020-01-01",
    genre_ids: [200, 201, 202, 203, 204]
  }
];

export const imagesStandupCh = [
  {
    id: "SwissComedyClub",
    title: "Swiss Comedy Club",
    label: "SwissComedyClub",
    backdrop_path: "/images/music-labels/standup-ch/rire-et-chansons.jpg",
    poster_path: "/images/music-labels/standup-ch/rire-et-chansons.jpg",
    overview: "SwissComedyClub - Humour et divertissement suisse",
    vote_average: 8.7,
    release_date: "2020-01-01",
    genre_ids: [300, 301]
  },
  {
    id: "52minutes",
    title: "52minutes",
    label: "52minutes",
    backdrop_path: "/images/music-labels/standup-ch/rire-et-chansons.jpg",
    poster_path: "/images/music-labels/standup-ch/rire-et-chansons.jpg",
    overview: "52minutes - Humour et divertissement suisse",
    vote_average: 8.7,
    release_date: "2020-01-01",
    genre_ids: [300, 301]
  },
  {
    id: "MontreuxComedy",
    title: "Montreux Comedy",
    label: "MontreuxComedy",
    backdrop_path: "/images/music-labels/standup-ch/rire-et-chansons.jpg",
    poster_path: "/images/music-labels/standup-ch/rire-et-chansons.jpg",
    overview: "MontreuxComedy - Humour et divertissement suisse",
    vote_average: 8.7,
    release_date: "2020-01-01",
    genre_ids: [300, 301]
  },
  {
    id: "comedieplus",
    title: "Comédie+",
    label: "comedieplus",
    backdrop_path: "/images/music-labels/standup-ch/rire-et-chansons.jpg",
    poster_path: "/images/music-labels/standup-ch/rire-et-chansons.jpg",
    overview: "Comédie+ - Humour et divertissement français",
    vote_average: 8.7,
    release_date: "2020-01-01",
    genre_ids: [300, 301]
  },
  {
    id: "RTSCouleur3",
    title: "RTSCouleur3",
    label: "RTSCouleur3",
    backdrop_path: "/images/music-labels/standup-ch/rire-et-chansons.jpg",
    poster_path: "/images/music-labels/standup-ch/rire-et-chansons.jpg",
    overview: "RTSCouleur3 - Humour et divertissement suisse",
    vote_average: 8.7,
    release_date: "2020-01-01",
    genre_ids: [300, 301]
  },
  {
    id: "Wieseltom",
    title: "Thomas Wiesel",
    label: "Wieseltom",
    backdrop_path: "/images/music-labels/standup-ch/rire-et-chansons.jpg",
    poster_path: "/images/music-labels/standup-ch/rire-et-chansons.jpg",
    overview: "Thomas Wiesel - Humour et standup suisse",
    vote_average: 8.7,
    release_date: "2020-01-01",
    genre_ids: [300, 301]
  },
  // {
  //   id: "rire-et-chansons",
  //   title: "Rire et Chansons",
  //   label: "RireEtChansons",
  //   backdrop_path: "/images/music-labels/standup-ch/rire-et-chansons.jpg",
  //   poster_path: "/images/music-labels/standup-ch/rire-et-chansons.jpg",
  //   overview: "Rire et Chansons - Humour et divertissement français",
  //   vote_average: 8.7,
  //   release_date: "2020-01-01",
  //   genre_ids: [300, 301]
  // },
  // {
  //   id: "comedie-plus",
  //   title: "Comédie+",
  //   label: "ComediePlus",
  //   backdrop_path: "/images/music-labels/standup-ch/comedie-plus.jpg",
  //   poster_path: "/images/music-labels/standup-ch/comedie-plus.jpg",
  //   overview: "Comédie+ - La chaîne 100% humour",
  //   vote_average: 8.5,
  //   release_date: "2020-01-01",
  //   genre_ids: [300, 301]
  // },
  // {
  //   id: "jamel-comedy-club",
  //   title: "Jamel Comedy Club",
  //   label: "JamelComedyClub",
  //   backdrop_path: "/images/music-labels/standup-ch/jamel-comedy-club.jpg",
  //   poster_path: "/images/music-labels/standup-ch/jamel-comedy-club.jpg",
  //   overview: "Jamel Comedy Club - Découverte de nouveaux talents",
  //   vote_average: 9.0,
  //   release_date: "2020-01-01",
  //   genre_ids: [300, 301]
  // },
  // {
  //   id: "kev-adams",
  //   title: "Kev Adams",
  //   label: "KevAdamsOfficiel",
  //   backdrop_path: "/images/music-labels/standup-ch/kev-adams.jpg",
  //   poster_path: "/images/music-labels/standup-ch/kev-adams.jpg",
  //   overview: "Kev Adams - Humoriste et acteur français",
  //   vote_average: 8.2,
  //   release_date: "2020-01-01",
  //   genre_ids: [300, 301]
  // },
  // {
  //   id: "gad-elmaleh",
  //   title: "Gad Elmaleh",
  //   label: "GadElmalehOfficiel",
  //   backdrop_path: "/images/music-labels/standup-ch/gad-elmaleh.jpg",
  //   poster_path: "/images/music-labels/standup-ch/gad-elmaleh.jpg",
  //   overview: "Gad Elmaleh - Humoriste franco-marocain",
  //   vote_average: 9.2,
  //   release_date: "2020-01-01",
  //   genre_ids: [300, 301]
  // },
  // {
  //   id: "florence-foresti",
  //   title: "Florence Foresti",
  //   label: "FlorenceForesti",
  //   backdrop_path: "/images/music-labels/standup-ch/florence-foresti.jpg",
  //   poster_path: "/images/music-labels/standup-ch/florence-foresti.jpg",
  //   overview: "Florence Foresti - Humoriste et actrice française",
  //   vote_average: 8.9,
  //   release_date: "2020-01-01",
  //   genre_ids: [300, 301]
  // }
];

export const imagesSport = [
  // {
  //   id: "FOOTBALL_LEAGUE",
  //   description: "Les meilleurs moments de la ligue de football.",
  //   title: "Football League",
  //   label: "FOOTBALL_LEAGUE",
  //   backdrop_path: "/images/sport/football.jpg",
  //   poster_path: "/images/sport/football.jpg",
  //   overview: "Chaîne officielle Football League.",
  //   vote_average: 9.0,
  //   release_date: "2021-09-01",
  // genre_ids: [400, 401, 402]
  // },
  // {
  //   id: "BASKETBALL_WORLD",
  //   description: "Revivez les plus grands matchs de basketball.",
  //   title: "Basketball World",
  //   label: "BASKETBALL_WORLD",
  //   backdrop_path: "/images/sport/basketball.jpg",
  //   poster_path: "/images/sport/basketball.jpg",
  //   overview: "Chaîne officielle Basketball World.",
  //   vote_average: 8.8,
  //   release_date: "2021-06-15",
  // genre_ids: [400, 401, 402]
  // },
  {
    id: "TRAIL_SHOW",
    description: "Revivez les plus grands moments de trail.",
    title: "Reportages",
    label: "TRAIL_SHOW",
    backdrop_path: "/images/sport/trail.jpg",
    poster_path: "/images/sport/trail.jpg",
    overview: "Chaîne officielle TRAIL_SHOW.",
    vote_average: 8.8,
    release_date: "2021-06-15",
    genre_ids: [400, 401, 402]
  },
  {
    id: "PREVIEW",
    description: "Revivez les plus grands moments de trail.",
    title: "En bref",
    label: "PREVIEW",
    backdrop_path: "/images/sport/trail.jpg",
    poster_path: "/images/sport/trail.jpg",
    overview: "Chaîne officielle PREVIEW.",
    vote_average: 8.8,
    release_date: "2021-06-15",
    genre_ids: [400, 401, 402]
  },
  {
    id: "TRAIL_INTERVIEW",
    description: "Revivez les plus grands moments de trail.",
    title: "Interviews",
    label: "TRAIL_INTERVIEW",
    backdrop_path: "/images/sport/trail.jpg",
    poster_path: "/images/sport/trail.jpg",
    overview: "Chaîne officielle TRAIL_INTERVIEW.",
    vote_average: 8.8,
    release_date: "2021-06-15",
    genre_ids: [400, 401, 402]
  },
  {
    id: "TRAIL_DOCUMENTARY",
    description: "Revivez les plus grands moments de trail.",
    title: "Documentaires",
    label: "TRAIL_DOCUMENTARY",
    backdrop_path: "/images/sport/trail.jpg",
    poster_path: "/images/sport/trail.jpg",
    overview: "Chaîne officielle TRAIL_DOCUMENTARY.",
    vote_average: 8.8,
    release_date: "2021-06-15",
    genre_ids: [400, 401, 402]
  },
  {
    id: "LIVE_STREAM",
    description: "Revivez les plus grands moments de trail.",
    title: "En direct",
    label: "LIVE_STREAM",
    backdrop_path: "/images/sport/trail.jpg",
    poster_path: "/images/sport/trail.jpg",
    overview: "Chaîne officielle LIVE_STREAM.",
    vote_average: 8.8,
    release_date: "2021-06-15",
    genre_ids: [400, 401, 402]
  },
  {
    id: "goldentrailseries7022",
    description: "Revivez les plus grands moments de trail.",
    title: "Golden Trail Series",
    label: "goldentrailseries7022",
    backdrop_path: "/images/sport/trail.jpg",
    poster_path: "/images/sport/trail.jpg",
    overview: "Chaîne officielle goldentrailseries7022.",
    vote_average: 8.8,
    release_date: "2021-06-15",
    genre_ids: [400, 401, 402]
  },
  {
    id: "lecomparatifdutrail",
    description: "Revivez les plus grands moments de trail.",
    title: "Le Comparatif du Trail",
    label: "lecomparatifdutrail",
    backdrop_path: "/images/sport/trail.jpg",
    poster_path: "/images/sport/trail.jpg",
    overview: "Chaîne officielle lecomparatifdutrail.",
    vote_average: 8.8,
    release_date: "2021-06-15",
    genre_ids: [400, 401, 402]
  }
];

export default {
  imagesWmb,
  imagesTropical,
  imagesStandupCh,
  imagesCultureFr,
  imagesspkombat,
  imagesSport
};
